import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirNavArrowLeft } from '@ng-icons/iconoir';
import { Route } from '../../../utils/route';
import { DictionaryService } from '../../../services/dictionary.service';
import { TabsComponent } from '../../../components/tabs/tabs.component';
import { SamplesDetailsTabComponent } from './samples-details-tab/samples-details-tab.component';

@Component({
  selector: 'app-samples-details',
  imports: [NgIcon, TabsComponent, SamplesDetailsTabComponent],
  providers: [provideIcons({ iconoirNavArrowLeft })],
  templateUrl: './samples-details.component.html',
  styleUrl: './samples-details.component.scss',
})
export class SamplesDetailsComponent extends Route implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  protected dictionaryService = inject(DictionaryService);

  catalogueId = signal<string>('');
  productName = signal<string>('');
  defaultTab = signal<string>('');

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.catalogueId.set(params['catalogueId'] || '');
      this.productName.set(params['productName'] || '');
    });

    this.route.queryParams.subscribe((params) => {
      this.defaultTab.set(params['tab'] || '');
    });
  }

  onTabChange(tab: string): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  goBack(): void {
    this.router.navigate(['/samples']);
  }
}